import {basicBaseApi} from "./basicBaseApi";
import {Methods} from '@newview/infrastructure';

/**
 * Api
 */
export class ShareinstancetoinstitutionApi extends basicBaseApi {
    public get ControllerName(): any {
        return 'shareinstancetoinstitution'
    }
    /**
     * 批量保存关系表
     * @param institutioninId 
     * @param roadId 
     * @param list 
     */
    public saveShareInstanceInstitution(institutioninId,roadId,struId,list){
      return this.send(list,"saveShareInstanceInstitution?institutioninId="+institutioninId+"&roadId="+roadId+"&struId="+struId,Methods.POST)
    }
    /**
     * 条件查询列表
     * @param institutioninId 
     * @param roadId 
     */
    public getListByFilter(institutioninId,roadId){
      return this.send({institutioninId:institutioninId,roadId:roadId},"getListByFilter",Methods.GET)
    }

    /**
     * 批量更新保存
     */
    public saveList(params){
        return this.send(params,"saveList",Methods.POST)
    }

       /**
     * 条件查询列表
     * @param institutioninId 
     * @param roadId 
     */
      public getgjList(institutioninId,roadId){
          return this.send({institutioninId:institutioninId,roadId:roadId},"getgjList",Methods.GET)
        }

   
}